import { render } from "./ProgramTimetableDayList.vue?vue&type=template&id=65436494"
import script from "./ProgramTimetableDayList.vue?vue&type=script&lang=js"
export * from "./ProgramTimetableDayList.vue?vue&type=script&lang=js"

import exportComponent from "/Volumes/Evolve/WorkSpace/MinonowaRadio/Ver2/frontend/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__